var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { staticClass: "service-ad" }, [
        _c("img", {
          staticClass: "service-ad__img hidden-mobile-down",
          attrs: { src: _vm.largeImage }
        }),
        _c("img", {
          staticClass: "service-ad__img hidden-mobile-up",
          attrs: { src: _vm.mobileImage }
        }),
        _c("div", {
          staticClass: "service-ad__close",
          on: { click: _vm.dismiss }
        }),
        _c("div", {
          staticClass: "service-ad__goto",
          on: { click: _vm.goAndDismiss }
        })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }